// Selectors for AssetBrowser filters state

// Filter values
export const selectApprovalStatus = (state) => state.filters.approvalStatus;
export const selectAssetTypes = (state) => state.filters.assetTypes;
export const selectAuthority = (state) => state.filters.authority;
export const selectCategory = (state) => state.filters.category;
export const selectCustomFacets = (state) => state.filters.customFacets;
export const selectDomainCategories = (state) => state.filters.domainCategories;
export const selectDomainCustomFacets = (state) => state.filters.domainCustomFacets;
export const selectDomainTags = (state) => state.filters.domainTags;
export const selectEnrolledInArchival = (state) => state.filters.enrolledInArchival;
export const selectOnlyRecentlyViewed = (state) => state.filters.onlyRecentlyViewed;
export const selectOwnedBy = (state) => state.filters.ownedBy;
export const selectRequester = (state) => state.filters.requester;
export const selectShowInternalTargetAudience = (state) => state.filters.showInternalTargetAudience;
export const selectShowPublicTargetAudience = (state) => state.filters.showPublicTargetAudience;
export const selectSource = (state) => state.filters.source;
export const selectSources = (state) => state.filters.sources;
export const selectTag = (state) => state.filters.tag;
export const selectUsersList = (state) => state.filters.usersList;
export const selectVersion = (state) => state.filters.version;
export const selectAllowedVersions = (state) => state.filters.allowedVersions;
export const selectVisibility = (state) => state.filters.visibility;

// All filters
export const selectAllFilters = (state) => state.filters;
